import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiClient} from "../../tools/api-client";
import {FoundMeasurement} from "./found-measurement";
import {map} from "rxjs/operators";

import {recursiveNullToUndefined} from "../../tools/recursive-null-to-undefined";
import {SelectedAnalyzer} from "./list-item";

@Injectable()
export class DoctorAssignmentService {
  constructor(private readonly apiClient: ApiClient) {
  }

  assignDoctor(
    assignDoctorRequest: AssignDoctorRequest,
  ): Observable<FoundMeasurement> {
    return this.apiClient.put<FoundMeasurement>(
      `/api/measurements/${assignDoctorRequest.measurementId}/doctor`,
      {
        selectedAnalyzer: assignDoctorRequest.selectedAnalyzer,
        patientDataLines: assignDoctorRequest.patientDataLines
      }
    ).pipe(map(listItem => recursiveNullToUndefined(listItem)));
  }
}

export interface AssignDoctorRequest {
  readonly measurementId: number;
  readonly selectedAnalyzer: SelectedAnalyzer;
  readonly patientDataLines: string[];
}
